var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditprofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 19.25H13.75M9 18.25L4.75 19.25L5.75 15L15.0429 5.70708C15.4334 5.31655 16.0666 5.31655 16.4571 5.70708L18.2929 7.54286C18.6834 7.93339 18.6834 8.56655 18.2929 8.95708L9 18.25Z",
    stroke: "#8A8AA3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditprofile);
export default __webpack_public_path__ + "static/media/editprofile.1e3d93fefab916b9d1142533bac3f853.svg";
export { ForwardRef as ReactComponent };